import { FaChevronRight } from 'react-icons/fa';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import { TbWallet } from 'react-icons/tb';
import { useRouter } from 'next/router';
import { IoPersonOutline, IoShieldOutline } from 'react-icons/io5';
import { TiDeleteOutline } from 'react-icons/ti';
import { BsLightning } from 'react-icons/bs';
import { useLocalStorage } from 'usehooks-ts';
import Intercom, { show, update } from '@intercom/messenger-js-sdk';
import { useEffect } from 'react';
import { IoIosNotificationsOutline } from 'react-icons/io';
import ImageWithFallback from '../shared/ImageWithFallback';
import GeniusLogo from '../shared/GeniusLogo';
import { useSession } from '@/contexts/LitSessionProvider';
import useIsAdmin from '@/hooks/auth/useIsAdmin';
import useAppDetails from '@/hooks/utilities/useAppDetails';
export default function ProfileDataMenu({
  pfp
}) {
  const router = useRouter();
  const {
    PKP
  } = useSession();
  const {
    setMobileMode
  } = useAppDetails();
  useEffect(() => {
    if (!PKP) return;
    Intercom({
      app_id: 'ei6xmnio',
      user_id: PKP?.username,
      // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
      name: PKP?.firstName,
      // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
      email: PKP?.email // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
    });
    update({
      hide_default_launcher: true
    });
  }, [PKP]);
  const [advancedMarketView, setAdvancedMarketView] = useLocalStorage('advance-data', false);
  const {
    isAdmin
  } = useIsAdmin();

  // const ProfileDataOld = [
  //   {
  //     title: 'Chat with Us',
  //     description: 'Immediate Support for Questions and Issues',
  //     icon: <GeniusLogo size={24} variant='pink' />,
  //     kind: '',
  //     func: () => {
  //       show();
  //     },
  //   },

  //   // {
  //   //   title: 'Settings',
  //   //   description: 'Manage your preferences',
  //   //   icon: <VscSettings size={20} />,
  //   //   kind: '',
  //   //   page: '/settings/settings',
  //   // },
  //   // {
  //   //   title: 'Bug Reports/Feature Requests',
  //   //   description: 'Report a Bug or Request a Feature',
  //   //   icon: <IoBugOutline size={20} />,
  //   //   kind: '',
  //   //   externalPage: 'https://support.tradegenius.com',
  //   // },
  //   {
  //     title: 'Advanced Mode',
  //     description: 'Manage your Trading and Display Settings',
  //     icon: <BsLightning size={20} />,
  //     kind: 'switch',
  //     page: null,
  //   },

  //   isAdmin
  //     ? {
  //       title: 'Admin',
  //       description: 'Admin Settings',
  //       icon: <IoPersonOutline size={20} />,
  //       kind: '',
  //       page: '/admin/settings',
  //     }
  //     : null,
  // ].filter((x) => x);

  const ProfileData = [{
    title: 'Chat with Us',
    description: 'Immediate Support for Questions and Issues',
    icon: <GeniusLogo size={24} variant='pink' />,
    kind: '',
    func: () => {
      show();
    }
  }, {
    title: 'Account',
    description: 'Username, PFP and Name Settings.',
    icon: <ImageWithFallback src={pfp} width={28} height={28} alt='account-settings-logo' className='rounded-lg' />,
    kind: '',
    func: () => {
      setMobileMode('settings_account');
      router.push('/home?m_mode=settings_account&prev_m_mode=settings', undefined, {
        shallow: true
      });
    }
  }, {
    title: 'Wallets',
    description: 'Your Genius Wallets and External Wallets',
    icon: <TbWallet size={20} />,
    kind: '',
    func: () => {
      setMobileMode('settings_wallets');
      router.push('/home?m_mode=settings_wallets&prev_m_mode=settings', undefined, {
        shallow: true
      });
    }
  }, {
    title: 'Security',
    description: 'Secure your Account',
    icon: <IoShieldOutline size={20} />,
    kind: '',
    func: () => {
      setMobileMode('settings_security');
      router.push('/home?m_mode=settings_security&prev_m_mode=settings', undefined, {
        shallow: true
      });
    }
  }, {
    title: 'Notifications',
    description: 'Manage your Notification Preferences',
    icon: <IoIosNotificationsOutline size={20} />,
    kind: '',
    func: () => {
      setMobileMode('settings_notifications');
      router.push('/home?m_mode=settings_notifications&prev_m_mode=settings', undefined, {
        shallow: true
      });
    }
  },
  // {
  //   title: 'Settings',
  //   description: 'Manage your preferences',
  //   icon: <VscSettings size={20} />,
  //   kind: '',
  //   page: '/settings/settings',
  // },
  // {
  //   title: 'Bug Reports/Feature Requests',
  //   description: 'Report a Bug or Request a Feature',
  //   icon: <IoBugOutline size={20} />,
  //   kind: '',
  //   externalPage: 'https://support.tradegenius.com',
  // },
  {
    title: 'Advanced Mode',
    description: 'Manage your Trading and Display Settings',
    icon: <BsLightning size={20} />,
    kind: 'switch',
    page: null
  }, {
    title: 'Account Deletion',
    description: 'Delete your Account',
    icon: <TiDeleteOutline size={20} />,
    kind: '',
    func: () => {
      setMobileMode('settings_account_del');
      router.push('/home?m_mode=settings_account_del&prev_m_mode=settings', undefined, {
        shallow: true
      });
    }
  }, isAdmin ? {
    title: 'Admin',
    description: 'Admin Settings',
    icon: <IoPersonOutline size={20} />,
    kind: '',
    func: () => {
      setMobileMode('settings_admin');
      router.push('/home?m_mode=settings_admin&prev_m_mode=settings', undefined, {
        shallow: true
      });
    }
  } : null].filter(x => x);
  return <div className='w-full self-start' data-sentry-component="ProfileDataMenu" data-sentry-source-file="profileDataMenu.tsx">
      {ProfileData.map((profileItem, index) => {
      return <div onClick={e => {
        if (profileItem.func) {
          e.preventDefault();
          profileItem.func();
        } else if (profileItem.page) {
          router.push(profileItem.page);
        } else if (profileItem.externalPage) window.open(profileItem.externalPage, '_blank');
      }} className={`w-full px-5 pt-1 flex justify-between items-center ${profileItem.title !== 'Community' && ''} hover:cursor-pointer transition-all text-genius-pink duration-300`} key={index}>
            <div className='flex items-center gap-x-4 h-14'>
              <div className='flex justify-center w-[28px]'>{profileItem.icon}</div>
              <div className='flex flex-col gap-y-[4px] items-start text-genius-cream'>
                <p className='text-base/4'>{profileItem.title}</p>
                <p className='text-genius-cream/50 text-xs/3'>{profileItem.description}</p>
              </div>
            </div>
            <div className='control'>
              {profileItem.kind === '' ? <FaChevronRight className='text-genius-cream' width={16} height={16} /> : profileItem.kind === 'null' ? '' : profileItem.kind === 'soon' ? <div className='items-center flex w-[94px] h-[33px] rounded-full bg-genius-blue text-genius-cream text-[16px] font-light ta-c justify-center'>
                  Soon!
                </div> : <SwitchPrimitives.Root checked={advancedMarketView} onClick={() => {
            setAdvancedMarketView(!advancedMarketView);
          }} className={`peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full
                     transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring
                      focus-visible:ring-offset-2 focus-visible:ring-offset-background 
                      disabled:cursor-not-allowed disabled:opacity-50 
                      ${advancedMarketView ? 'bg-genius-pink' : 'bg-genius-blue'} `}>
                  <SwitchPrimitives.Thumb className='pointer-events-none block h-5 w-5 rounded-full shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0  data-[state=checked]:bg-genius-blue data-[state=unchecked]:bg-genius-pink' />
                </SwitchPrimitives.Root>}
            </div>
          </div>;
    })}
    </div>;
}